import { render, staticRenderFns } from "./Onus.vue?vue&type=template&id=b3ea1bae&"
import script from "./Onus.vue?vue&type=script&lang=js&"
export * from "./Onus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports